var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "supplier-order-panel" },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "toolbar-title" }, [_vm._v("供应商订单记录")]),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: {
                  size: "mini",
                  icon: "el-icon-refresh",
                  loading: _vm.loading,
                },
                on: { click: _vm.getList },
              },
              [_vm._v("刷新")]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  size: "mini",
                  type: "primary",
                  icon: "el-icon-upload2",
                  loading: _vm.submitLoading,
                },
                on: { click: _vm.handleSubmit },
              },
              [_vm._v(" 补偿下单 ")]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  size: "mini",
                  type: "success",
                  icon: "el-icon-search",
                  disabled: !_vm.records.length,
                  loading: _vm.syncLoading,
                },
                on: { click: _vm.handleSync },
              },
              [_vm._v(" 同步状态 ")]
            ),
          ],
          1
        ),
      ]),
      _c("el-alert", {
        staticClass: "mb15",
        attrs: {
          type: "warning",
          closable: false,
          "show-icon": "",
          title:
            "手动兜底：补偿下单会重新调用开放平台下单链路；同步状态会主动查询开放平台订单列表并回写本地记录。",
        },
      }),
      _vm.invoiceLoadFailed
        ? _c("el-alert", {
            staticClass: "mb15",
            attrs: {
              type: "error",
              closable: false,
              "show-icon": "",
              title: "发货单读取失败，物流信息暂不可核验，请点击刷新重试。",
            },
          })
        : _vm._e(),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.records,
            size: "small",
            border: "",
            "empty-text": "暂无供应商订单记录",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "supplierCode",
              label: "供应商",
              "min-width": "110",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "orderSn",
              label: "本地订单号",
              "min-width": "190",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "orderId",
              label: "开放平台主单号",
              "min-width": "190",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pushOrderSn",
              label: "开放平台子单号",
              "min-width": "190",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "goodsNo",
              label: "规格/货号",
              "min-width": "100",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "订单状态", "min-width": "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "mini",
                          type: _vm.statusTagType(scope.row.status),
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.formatStatus(scope.row.status)) + " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "afterSalesStatus",
              label: "售后状态",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm.formatAfterSalesStatus(scope.row.afterSalesStatus)
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "物流公司", "min-width": "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.shipments.length
                      ? _vm._l(scope.row.shipments, function (shipment) {
                          return _c(
                            "div",
                            {
                              key: shipment.id,
                              staticClass: "shipment-line",
                              attrs: {
                                title:
                                  shipment.expressName || shipment.expressCode,
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    shipment.expressName ||
                                      shipment.expressCode ||
                                      "-"
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        })
                      : _c("span", [_vm._v(_vm._s(scope.row.delivery || "-"))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "物流单号", "min-width": "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.shipments.length
                      ? _vm._l(scope.row.shipments, function (shipment) {
                          return _c(
                            "div",
                            {
                              key: shipment.id,
                              staticClass: "shipment-line",
                              attrs: { title: shipment.trackingNumber },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(shipment.trackingNumber) + " "
                              ),
                            ]
                          )
                        })
                      : _c("span", [
                          _vm._v(_vm._s(scope.row.deliveryNo || "-")),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "payPrice", label: "成本金额", "min-width": "90" },
          }),
          _c("el-table-column", {
            attrs: { label: "接口信息", width: "110", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.info
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              "aria-label":
                                "查看供应商订单记录 " +
                                scope.row.id +
                                " 的接口信息",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showInfo(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看详情")]
                        )
                      : _c("span", { staticClass: "empty-info" }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "updateTime",
              label: "更新时间",
              "min-width": "160",
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "接口信息 · 记录 #" + _vm.infoRecordId,
            visible: _vm.infoVisible,
            width: "min(720px, calc(100vw - 32px))",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.infoVisible = $event
            },
          },
        },
        [
          _c("pre", { staticClass: "info-content" }, [
            _vm._v(_vm._s(_vm.infoContent)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }